export default __webpack_public_path__ + "assets/israel-flag.png";